export const menuMap = [
    /**{
      label: "Gestione Quesiti",
      icon: "bi bi-question-circle",
      children: [
        {
          label: "Crea Quesito",
          view: "QuestionView",
          icon: "bi bi-plus-circle",
          requiredPermissions: ["create-question"]
        },
        {
          label: "Quesiti",
          view: "ListaQuesitiView",
          icon: "bi bi-list-ul",
          requiredPermissions: ["view-question", "edit-question"]
        }
      ]
    },*/
    {
      label: "Gestione Pareri",
      icon: "bi bi-chat-left-text",
      children: [
        {
          label: "Crea Parere",
          view: "CreaParereView",
          icon: "bi bi-plus-square",
          requiredPermissions: ["create-opinion"]
        },
        {
          label: "Lista Pareri",
          view: "ListaPareriView",
          icon: "bi bi-journal-text",
          requiredPermissions: ["view-opinion", "edit-opinion"]
        }
      ]
    },
    {
      label: "GESTIONE UOC",
      icon: "bi bi-diagram-3",
      view: "GestioneUOCView",
      requiredPermissions: ["manage-uoc"]
    },
  {
    label: "ELENCO QUESITI",
    view: "QuestionsView",
    requiredPermissions: ["view-question", "edit-question"]
  },
  {
    label: "NUOVO QUESITO",
    view: "ArticlesView",//"QuestionView",
    requiredPermissions: ["create-question"]
  },
  {
    label: "DATI ANAGRAFICI",
    view: "UserDetailView",
    requiredPermissions: ["view-users"]
  }
  ];